import React, { useRef, useState } from 'react';

export default function LandingVideo({ imgSrc, videoSrc, aspectRatio, videoRef, }) {

    const [loading, setLoading] = useState(true);
    const handleLoadedData = () => setLoading(false);
    return (
        <div
            className="arcads-video"
            style={{
                minWidth: '102%', minHeight: '102%', width: 'auto', height: 'auto',
                position: 'absolute',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                aspectRatio: aspectRatio,
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)'
            }}

        >
            {loading && (
                <div
                    style={{
                        aspectRatio,
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        overflow: 'hidden',
                    }}
                >
                    <img style={{ height: '100%', width: 'auto' }} src={imgSrc} alt="" />
                </div>
            )}

            <video
                ref={videoRef}
                style={{ width: '100%', height: '100%' }}
                autoPlay={videoRef ? false : true}
                loop
                muted
                playsInline
                onLoadedData={handleLoadedData}
            >
                <source src={videoSrc} type="video/mp4" />
            </video>
        </div>
    );
}
